import { env } from '@/environments';

const appRootUrl = window.location.origin;

const oidcSettings = {
  authority: env.authUrl,
  clientId: env.authClientId,
  redirectUri: `${appRootUrl}/callback`,
  responseType: 'id_token token',
  scope: env.authScope,
  postLogoutRedirectUri: `${appRootUrl}/logout`,
  silentRedirectUri: `${appRootUrl}/callback`,
  revokeAccessTokenOnSignout: true,
};

export { oidcSettings };
